import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'wouter';

import { useAddToast } from '../../../contexts/ToastContext';
import RequestForm from '../../forms/Request';
import PageMeta from '../../partials/PageMeta';
import Title from '../../typography/Title';

import styles from '../../../../styles/pages/auth.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function ResetPage({ page = null }) {
    const route = useUrlGenerator();
    const [, setLocation] = useLocation();
    const addToast = useAddToast();

    const { title = null, action = null, fields = null } = page || {};
    const onComplete = useCallback(() => {
        addToast({
            id: 'request-password',
            title: (
                <FormattedMessage
                    defaultMessage="Password reset request sent"
                    description="Toast title"
                />
            ),
            theme: 'success',
            description: (
                <FormattedMessage
                    defaultMessage="Check your email for instructions."
                    description="Toast description"
                />
            ),
        });
        setLocation(route('login'));
    }, [route, setLocation, addToast]);

    return (
        <div className={styles.container}>
            <PageMeta page={page} />
            <Title className={styles.title} size="mediumLarge">
                {title}
            </Title>
            <RequestForm
                className={classNames([styles.form, styles.centered])}
                action={action}
                fields={fields}
                onComplete={onComplete}
            />
            <p className={styles.notice}>
                <FormattedMessage
                    defaultMessage="Remember your passsword afterall?"
                    description="Button label"
                />
                &nbsp;
                <Link className={styles.helpLink} href={route('login')}>
                    <FormattedMessage defaultMessage="Login here." description="Button label" />
                </Link>
            </p>
        </div>
    );
}

ResetPage.propTypes = propTypes;

export default ResetPage;
